module.exports = __webpack_public_path__ + "static/media/dm-header.50cd194d.jpg";